import Splide from '@splidejs/splide';

/**
 * Technology suite carousel.
 *
 * One card at a time with the next one peeking in from the right, so the row
 * reads as continuing past the edge. The controls live in the section's own
 * markup - Splide adopts .splide__arrows and .splide__pagination when it finds
 * them - which is what puts the dots bottom-left and the arrows bottom-right.
 */
const initTechSuite = (slider) => {
  const slides = slider.querySelectorAll('.splide__slide').length;

  if (!slides) {
    return;
  }

  const splide = new Splide(slider, {
    type: slides > 1 ? 'loop' : 'slide',
    perPage: 1,
    perMove: 1,
    focus: 0,
    gap: '1.875rem',
    padding: { right: '30%' },
    arrows: slides > 1,
    pagination: slides > 1,
    speed: 650,
    drag: slides > 1,
    keyboard: 'focused',
    breakpoints: {
      1024: {
        padding: { right: '18%' },
      },
      768: {
        gap: '1.25rem',
        padding: { right: '12%' },
      },
      640: {
        gap: '1rem',
        padding: { right: '8%' },
      },
    },
    reducedMotion: {
      speed: 0,
      rewindSpeed: 0,
    },
  });

  const updateCarouselUi = () => {
    const track = slider.querySelector('.splide__track');
    const activeSlide = slider.querySelector('.splide__slide.is-active');

    if (!track || !activeSlide) {
      return;
    }

    const sliderRect = slider.getBoundingClientRect();
    const trackRect = track.getBoundingClientRect();
    const nextSlide = activeSlide.nextElementSibling;
    const previousX = trackRect.left - sliderRect.left;
    const nextX = nextSlide
      ? previousX + nextSlide.offsetLeft - activeSlide.offsetLeft
      : previousX + activeSlide.offsetWidth;

    slider.style.setProperty(
      '--tech-suite-track-center',
      `${trackRect.top - sliderRect.top + trackRect.height / 2}px`
    );
    slider.style.setProperty('--tech-suite-prev-x', `${previousX}px`);
    slider.style.setProperty('--tech-suite-next-x', `${nextX}px`);
  };

  splide.on('mounted moved resized', updateCarouselUi);
  splide.mount();
};

const initAll = () => {
  document.querySelectorAll('[data-tech-suite-slider]').forEach((slider) => {
    if (slider.dataset.techSuiteInitialized) {
      return;
    }

    slider.dataset.techSuiteInitialized = 'true';
    initTechSuite(slider);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}
